import { render, staticRenderFns } from "./PricingPlans.vue?vue&type=template&id=fe41bdf4&scoped=true"
import script from "./PricingPlans.vue?vue&type=script&lang=js"
export * from "./PricingPlans.vue?vue&type=script&lang=js"
import style0 from "./PricingPlans.vue?vue&type=style&index=0&id=fe41bdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe41bdf4",
  null
  
)

export default component.exports